import { render, staticRenderFns } from "./AccounBalances.vue?vue&type=template&id=e379d760"
import script from "./AccounBalances.vue?vue&type=script&lang=js"
export * from "./AccounBalances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports